import { render, staticRenderFns } from "./TdNumber.vue?vue&type=template&id=fc23bd46&"
import script from "./TdNumber.vue?vue&type=script&lang=ts&"
export * from "./TdNumber.vue?vue&type=script&lang=ts&"
import style0 from "./TdNumber.vue?vue&type=style&index=0&id=fc23bd46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports